import React from 'react'

import { Route, Switch } from 'react-router-dom'

import Dashboard from '../pages/Dashboard'
import Customers from '../pages/Customers'
import IdDistinguish from '../pages/IdDistinguish/index'
import BankCardDistinguish from '../pages/BankCardDistinguish/index'
import WordsDistinguish from '../pages/WordsDistinguish/index'
import TicketsDistinguish from '../pages/TicketsDistinguish/index'
import SubjectRecognition from '../pages/SubjectRecognition/index'
const Routes = () => {
    return (
        <Switch>
            <Route path='/IdDistinguish' component={IdDistinguish}/>
            <Route path='/Dashboard' exact component={Dashboard}/>
            <Route path='/customers' component={Customers}/>
            <Route path='/BankCardDistinguish' component={BankCardDistinguish}/>
            <Route path='/WordsDistinguish' component={WordsDistinguish}/>
            <Route path='/TicketsDistinguish' component={TicketsDistinguish}/>
            <Route path='/SubjectRecognition' component={SubjectRecognition}/>
            <Route path='/' component={SubjectRecognition}/>
        </Switch>
    )
}

export default Routes
